import ScoreBasketball from "./ScoreBasketball";
export default ScoreBasketball;
